export default __webpack_public_path__ + "static/media/demo-puzzel-menu.7ff14571.png";